import React from "react";
import { noDataImage } from "../../assets/layout";
import { useUtils } from "../../customHooks/useUtils";

function NoDeviceCardError({
  message,
  className,
}: {
  message?: string;
  className?: string;
}) {
  const { FEEDBACK_MESSAGES } = useUtils();
  return (
    <div className="flex flex-col  justify-center items-center h-full w-full">
      <img
        src={noDataImage}
        alt="unable to fetch data"
        className={`max-h-[80px] ${className}`}
      />
      <span className="font-semibold">
        {message || FEEDBACK_MESSAGES.NO_DEVICE}
      </span>
    </div>
  );
}

export default NoDeviceCardError;
